import { useTranslation } from 'react-i18next';
import React, {useEffect} from 'react';

const CtaPopup = (props) => {
    useEffect(() => {
        // scroll back to top page
        window.scrollTo(0, 0);
    });

    const [t, ] = useTranslation('result');

    const yesAction = () => {
        this.closePopup();
        window.scrollTo(0, 0);
        props.yesAction();
        this.closePopup();
    };

    const closePopup = () => window.$('.postresult').hide();

    return (
        <div className="cta-popup-container container">
            <h2>{props.title}</h2>
            <p>{props.text}</p>
            <div className="button-container row">
                <div className="col">
                    <button className="col btn btn-primary" onClick={yesAction}>{t('CtaPopup-Ja')}</button>
                    <button className="col btn btn-default" onClick={closePopup}>{t('CtaPopup-Nee')}</button>
                </div>
            </div>
        </div>
    );
};

export default CtaPopup;
